/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, InfoRequestSent } from './styles';
import history from '~/services/history';

export default function RequestSent(props) {
  const [topic, setTopic] = useState('');
  const [reference, setReference] = useState('');
  const [businessId, setBusinessId] = useState(0);
  const [address, setAddress] = useState('');

  useEffect(() => {
    if (props && props.location && props.location.state) {
      const {
        sAddress,
        sBusinessId,
        sReference,
        sTopic,
      } = props.location.state;
      setAddress(sAddress);
      setBusinessId(sBusinessId);
      setReference(sReference);
      setTopic(sTopic);
    }
  }, [props, reference]);

  function handleOpenMyAds() {
    history.push({
      pathname: '/MeusAnuncios',
      state: {
        sBusinessId: businessId,
        sReference: reference,
        sAddress: address,
        sTopic: 'Meus Anúncios',
      },
    });
  }

  return (
    <Container>
      <div className="header">
        <h1>{topic}</h1>

        <div>
          <span>Ref.: {reference}</span>
          <span>Nº do negócio: {businessId}</span>
          <span>{address}</span>
        </div>
      </div>

      <InfoRequestSent>
        <p>Sua solicitação de alteração do anúncio foi enviada com sucesso!</p>
        <p>Nossa equipe irá analisá-la e entraremos em contato com você</p>
      </InfoRequestSent>
      <div className="buttonMyAdss">
        <button
          type="button"
          className="button"
          onClick={() => handleOpenMyAds()}
        >
          Meus Anúncios
        </button>
      </div>
    </Container>
  );
}

RequestSent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
};
